export default function QuotePageFooter() {
  return (
    <footer className="quote-page-footer">
      <span>
        <i className="bi bi-shield-check" aria-hidden="true" />
        M-Motors · Votre mobilité en toute confiance
      </span>
    </footer>
  );
}
